// extracted by mini-css-extract-plugin
export var bachelor = "employees-module--bachelor--1d3a7";
export var cert = "employees-module--cert--b1179";
export var certificates = "employees-module--certificates--56336";
export var container = "employees-module--container--a8876";
export var degElement = "employees-module--degElement--48373";
export var degree = "employees-module--degree--2c671";
export var employeeWrap = "employees-module--employeeWrap--abef0";
export var entry = "employees-module--entry--60460";
export var excerpt = "employees-module--excerpt--42432";
export var image = "employees-module--image--829eb";
export var master = "employees-module--master--ed646";
export var preview = "employees-module--preview--3c9a7";
export var title = "employees-module--title--5bddb";